export var valuesSessionInformationType = ["Media", "MediaWithoutThumbnails", "Text", "Number", "Choice"];
/*

*/ 
//# sourceMappingURL=SessionInformationType.js.map